import { LinearProgress } from '@mui/joy';

import { PromptOptimizationLog } from '@/types/schema';

import { LogItem } from './LogItem';

export const Logs = ({
  logs,
  isCompleted,
}: {
  logs?: PromptOptimizationLog[];
  isCompleted: boolean;
}) => (
  <div className="flex flex-col gap-2 rounded-md bg-gray-50 p-4">
    {logs?.map((log, idx) => (
      <LogItem key={idx} log={log} />
    ))}
    {!isCompleted && <LinearProgress />}
  </div>
);
